import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { taglineVariants } from '../animations';

const LOGO_URL =
  'https://cdn.prod.website-files.com/6829acf870093a50cc6ceb69/682b03419ead6e45d8f2c59e_logo%20(2).svg';

const LoginLogo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={taglineVariants}
      initial="initial"
      animate="animate"
      className="text-center mb-10"
    >
      <div className="inline-flex items-center justify-center w-20 h-20">
        <img
          src={LOGO_URL}
          alt={t('appName') ?? 'HAAT'}
          className="w-full h-full object-contain"
          loading="eager"
        />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">
        {t('partnerAuth.welcome.title')}
      </h1>
      <p className="text-gray-500">
        {t('partnerAuth.welcome.subtitle')}
      </p>
    </motion.div>
  );
};

export default LoginLogo;
